<template>
	<div
		class="flex items-center"
		:class="{
			'justify-between': title,
			'justify-end': !title,
		}"
	>
		<v-h4 v-if="title" :tag="titleTag">
			{{ title }}
		</v-h4>

		<div class="hidden items-center space-x-2 text-black md:flex">
			<v-scrollable-button
				direction="previous"
				@keydown.left="$emit('move', -1)"
				@click="$emit('move', -1)"
			>
				<v-icon icon="chevron-left" class="text-xl"></v-icon>
			</v-scrollable-button>

			<v-scrollable-button
				direction="next"
				@keydown.right="$emit('move', 1)"
				@click="$emit('move', 1)"
			>
				<v-icon icon="chevron-right" class="text-xl"></v-icon>
			</v-scrollable-button>
		</div>
	</div>
</template>

<script lang="ts" setup>
defineProps<{
	title?: string;
	titleTag?: string;
}>();

defineEmits<{
	(event: "move", direction: number): void;
}>();
</script>
